<div class="h-1 w-full" *ngIf="!loaded">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex flex-col w-full preview-asset-summary overflow-y-auto overflow-x-hidden zuper-scrollbar primary-font"
    *ngIf="loaded">
    <div class="relative w-full p-6 pt-7 pb-4 bg-accent-100 flex-shrink-0 dark:bg-accent-700 z-0 border-b">
        <img class="absolute inset-0 object-cover w-full h-full image-filter-blur" *ngIf="assetDetails.asset_image"
            src="{{assetDetails.asset_image}}" alt="">
        <div class="flex items-center justify-end w-full max-w-3xl mx-auto">
            <button mat-icon-button matTooltip="{{'close.text' | translate}}"
                matTooltipPosition="above"
                class="mat-focus-indicator mat-tooltip-trigger mat-icon-button mat-button-base" tabindex="0"
                (click)="closeDrawer()">
                <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                    data-mat-icon-type="svg" data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                    <em class="ti ti-x"></em>
                </mat-icon>
            </button>
        </div>
        <div class="relative flex w-full mt-4">
            <div *ngIf="assetDetails.asset_status"
                class="ml-auto cursor-default inline-flex px-2 py-0.5 rounded text-base bg-gray-100 text-gray-600 border">
                <span class="mt-1">
                    <svg xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-circle asset-status-{{assetDetails.asset_status}}"
                        width="11" height="11" viewBox="0 0 24 24" stroke-width="0" stroke="currentColor" fill="none"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <circle cx="12" cy="12" r="9"></circle>
                    </svg>
                </span>
                <span class="text-md font-medium px-1 truncate">
                    {{getAssetStatusValue(assetDetails.asset_status) | titlecase}}
                </span>
            </div>
        </div>
    </div>
    <div class="-mt-12 flow-root px-4 sm:-mt-8 sm:flex sm:items-end sm:px-6 pb-2 z-10">
        <div class="-m-1 flex">
            <div class="inline-flex overflow-hidden rounded-lg border-4 border-white shadow-md flex-shrink-0">
                <img *ngIf="assetDetails.asset_image" class="h-30 w-30 flex-shrink-0 sm:h-30 sm:w-30 lg:h-30 lg:w-30"
                    src="{{assetDetails.asset_image}}" alt="">
                <img *ngIf="!assetDetails.asset_image" class="h-30 w-30 flex-shrink-0 sm:h-30 sm:w-30 lg:h-30 lg:w-30"
                    src="assets/images/png/cubes.png" alt="">
            </div>
        </div>
        <div class="m-4 sm:ml-6 sm:flex-1 w-2/4">
            <div class="flex items-center">
                <h3 class="text-xl font-bold text-gray-900 sm:text-2xl truncate"
                    matTooltip="{{assetDetails.asset_name}}">{{assetDetails.asset_name}}</h3>
            </div>
            <p class="text-base text-gray-500 mt-1 truncate"
                *ngIf="assetDetails.asset_category && assetDetails.asset_category.category_name">
                {{assetDetails.asset_category.category_name}}</p>
        </div>
        <div class="my-6 ml-auto">
            <a target="_blank" class="hidden" #viewAssetDetails href="{{getRedirectLink()}}"></a>
            <button mat-icon-button matTooltip="{{'text.view_details.new_tab' | translate}}"
                matTooltipPosition="above" (click)="viewAssetDetails.click($event)">
                <mat-icon class="icon-size-6">open_in_new</mat-icon>
            </button>
        </div>
    </div>
    <div class="flex flex-col w-full z-10">
        <div class="flex flex-col py-5 px-6 w-full border-b">
            <div class="py-1.5 flex">
                <span class="text-base font-medium flex-item-wrap-leftContent">
                    {{'asset_code' | translate}}
                </span>
                <span class="text-base font-medium mr-2">:</span>
                <span class="text-base text-gray-500 flex-item-wrap">{{assetDetails.asset_code}}
                </span>
            </div>
            <div class="py-1.5 flex" *ngIf="assetDetails.asset_serial_number?.length">
                <span class="text-base font-medium flex-item-wrap-leftContent">
                    {{'text.serial_number' | translate}}
                </span>
                <span class="text-base font-medium mr-2">:</span>
                <span
                    class="text-base text-gray-500  flex-item-wrap">{{utilityService.getAssetSerialNumber(assetDetails.asset_serial_number)}}
                </span>
            </div>
            <div class="py-1.5 flex">
                <span class="text-base font-medium flex-item-wrap-leftContent">
                    {{'assets.preview.panel.ownership' | translate}}
                </span>
                <span class="text-base font-medium mr-2">:</span>
                <span class="text-base text-gray-500  flex-item-wrap">
                    {{(assetDetails.owned_by_customer ? 'text.owned_by_customer' :
                    'text.owned_by_us') | translate}}
                </span>
            </div>
            <div class="py-1.5 flex" *ngIf="assetDetails.customer">
                <span class="text-base font-medium flex-item-wrap-leftContent">
                    {{'customer' | translate}}
                </span>
                <span class="text-base font-medium mr-2">:</span>
                <a class="text-base text-gray-500 flex-item-wrap hover:underline hover:text-primary-500 cursor-pointer"
                    *ngIf="!assetDetails.customer.is_deleted && isCustomerAccessible" target="_blank"
                    [routerLink]="utilityService.getLink('CUSTOMER', assetDetails.customer?.customer_uid)">
                    {{assetDetails.customer.customer_first_name}} {{assetDetails.customer.customer_last_name ?? ''}}
                </a>
                <a class="text-base text-gray-500 flex-item-wrap cursor-default"
                    *ngIf="assetDetails.customer.is_deleted === true || !isCustomerAccessible">
                    {{assetDetails.customer.customer_first_name}} {{assetDetails.customer.customer_last_name ?? ''}}
                </a>
            </div>
            <div class="py-1.5 flex" *ngIf="assetDetails.organization">
                <span class="text-base font-medium flex-item-wrap-leftContent">
                    {{'text.organization' | translate}}
                </span>
                <span class="text-base font-medium mr-2">:</span>
                <a class="text-base text-gray-500 flex-item-wrap hover:underline hover:text-primary-500 cursor-pointer"
                    *ngIf="!assetDetails.organization.is_deleted && isOrganizationAccessible" target="_blank"
                    [routerLink]="utilityService.getLink('ORGANIZATION', assetDetails.organization?.organization_uid)">
                    {{assetDetails.organization.organization_name}}
                </a>
                <a class="text-base text-gray-500 flex-item-wrap cursor-default"
                    *ngIf="assetDetails.organization.is_deleted === true || !isOrganizationAccessible">
                    {{assetDetails.organization.organization_name}}
                </a>
            </div>
            <div class="py-1.5 flex" *ngIf="assetDetails.asset_location">
                <div class="flex flex-col w-full cursor-default">
                    <div class="flex">
                        <span class="text-base font-medium">
                            {{'text.asset_location' | translate}}</span>
                    </div>
                    <div class="flex mt-1.5">
                        <span
                            class="text-base text-gray-500">{{utilityService.getFormattedAddress(assetDetails.asset_location)}}</span>
                    </div>
                </div>
                <div class="flex -mt-3"
                    *ngIf="assetDetails.asset_location?.geo_cordinates && assetDetails.asset_location?.geo_cordinates.length > 1">
                    <a class="flex items-center justify-center rounded-full h-10 w-10 p-2 hover:bg-gray-200 text-primary-500 cursor-pointer"
                        target="_blank" [matTooltip]="('text.view_on_map' | translate)"
                        href="{{utilityService.getMapsCoordinatesUrl(assetDetails.asset_location.geo_cordinates[0], assetDetails.asset_location.geo_cordinates[1])}}">
                        <em class="ti ti-location icon-size-4.5 font-semibold"></em>
                    </a>
                </div>
            </div>
        </div>
        <mat-accordion class="border-b">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title class="text-secondary font-bold text-base primary-font">
                        {{'assets.preview.info.header' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="flex flex-wrap py-2 px-6 primary-font">
                    <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap">
                        <p class="font-medium leading-5 truncate text-base text-gray-500">
                            {{'text.asset_product' | translate}}</p>
                        <a class="text-md text-gray-900 hover:underline hover:text-primary cursor-pointer"
                            *ngIf="assetDetails.asset_product"
                            [routerLink]="utilityService.getLink('PRODUCTS', assetDetails.asset_product?.product_uid)">
                            {{assetDetails.asset_product.product_name}}</a>
                        <span class="text-md text-gray-900" *ngIf="!assetDetails.asset_product">
                            {{'---'}}</span>
                    </div>
                    <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap">
                        <p class="font-medium leading-5 truncate text-base text-gray-500">
                            {{'text.parent_asset' | translate}}</p>
                        <a class="text-md text-gray-900 hover:underline hover:text-primary cursor-pointer"
                            *ngIf="assetDetails.parent_asset"
                            [routerLink]="utilityService.getLink('ASSETS', assetDetails.parent_asset?.asset_uid)">
                            {{assetDetails.parent_asset.asset_name}}</a>
                        <span class="text-md text-gray-900" *ngIf="!assetDetails.parent_asset">
                            {{'---'}}</span>
                    </div>
                    <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap">
                        <p class="font-medium leading-5 truncate text-base text-gray-500">
                            {{'text.purchase_date' | translate}}</p>
                        <span class="text-md text-gray-900">
                            {{assetDetails.purchase_date ? (assetDetails.purchase_date | dateformat) : '---'}}</span>
                    </div>
                    <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap">
                        <p class="font-medium leading-5 truncate text-base text-gray-500">
                            {{'text.purchase_price' | translate}}</p>
                        <span class="text-md text-gray-900">
                            {{assetDetails.purchase_price ? (currency + ' ' + (assetDetails.purchase_price | number:
                            digitsInfo)) : '---'}}</span>
                    </div>
                    <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap">
                        <p class="font-medium leading-5 truncate text-base text-gray-500">
                            {{'text.placed_in_service' | translate}}</p>
                        <span class="text-md text-gray-900">
                            {{assetDetails.placed_in_service ? (assetDetails.placed_in_service | dateformat) :
                            '---'}}</span>
                    </div>
                    <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap">
                        <p class="font-medium leading-5 truncate text-base text-gray-500">
                            {{'text.warranty_date' | translate}}</p>
                        <span class="text-md text-gray-900">
                            {{assetDetails.warranty_expiry_date ? (assetDetails.warranty_expiry_date | dateformat) :
                            '---'}}</span>
                    </div>
                    <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap">
                        <p class="font-medium leading-5 truncate text-base text-gray-500">
                            {{'text.residual_price' | translate}}</p>
                        <span class="text-md text-gray-900">
                            {{assetDetails.residual_price ? (currency + ' ' + (assetDetails.residual_price | number:
                            digitsInfo)) : '---'}}</span>
                    </div>
                    <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap">
                        <p class="font-medium leading-5 truncate text-base text-gray-500">
                            {{'text.useful_life' | translate}}</p>
                        <span class="text-md text-gray-900">
                            {{assetDetails.useful_life && assetDetails.useful_life.value ?
                            (assetDetails.useful_life.value + ' ' +
                            assetDetails.useful_life.type) : '---'}}</span>
                    </div>
                    <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap"
                        *ngIf="assetDetails.last_service_date">
                        <p class="font-medium leading-5 truncate text-base text-gray-500">
                            {{'text.last_service_date' | translate}}</p>
                        <span class="text-md text-gray-900">
                            {{assetDetails.last_service_date | dateformat}}</span>
                    </div>
                    <div class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 dark:bg-hover flex-item-wrap"
                        *ngIf="assetDetails.next_service_date">
                        <p class="font-medium leading-5 truncate text-base text-gray-500">
                            {{'text.next_service_date' | translate}}</p>
                        <span class="text-md text-gray-900">
                            {{assetDetails.next_service_date | dateformat}}</span>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion class="border-b">
            <mat-expansion-panel [expanded]="assetDetails.asset_parts?.length === 1">
                <mat-expansion-panel-header>
                    <mat-panel-title class="text-secondary font-bold text-base primary-font">
                        {{'text.asset_parts' | translate}} ({{assetDetails.asset_parts?.length ?? 0}})
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="flex flex-col flex-auto overflow-auto max-h-80 m-6 border-l border-r hover-stripped"
                    *ngIf="dataSource.length">
                    <table mat-table [dataSource]="dataSource" class="asset-products-table primary-font"
                        aria-describedby="Asset Products">
                        <!-- Asset Name Column -->
                        <ng-container matColumnDef="assetName">
                            <th mat-header-cell *matHeaderCellDef
                                class="text-left text-sm font-semibold text-gray-500 border-light border-t border-b uppercase">
                                {{'asset_name' | translate}} </th>
                            <td mat-cell *matCellDef="let element" class="text-base">
                                {{element.product_id.product_name}} </td>
                        </ng-container>
                        <!-- Quantity Column -->
                        <ng-container matColumnDef="quantity">
                            <th mat-header-cell *matHeaderCellDef
                                class="text-left text-sm font-semibold text-gray-500 border-light border-t border-b uppercase">
                                {{'text.quantity' | translate}} </th>
                            <td mat-cell *matCellDef="let element" class="text-base"> {{element.quantity ?? ''}}
                                {{element.product_id.uom ?? ''}} </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true;" class="bg-gray-50"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
                <div class="h-60 flex flex-col items-center justify-center primary-font"
                    *ngIf="dataSource.length === 0">
                    <div class="flex flex-col items-center justify-center">
                        <img class="w-40 m-auto" src="assets/images/svgs/no_parts_found.svg"
                            alt="No parts added for this asset">
                        <h4 class="font-medium mt-4 text-secondary">{{'assets.preview.panel.noParts_found' | translate}}
                        </h4>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion class="border-b">
            <mat-expansion-panel [expanded]="jobsCount === 1">
                <mat-expansion-panel-header>
                    <mat-panel-title class="text-secondary font-bold text-base primary-font">
                        {{'text.asset_jobs' | translate}} ({{jobsCount}})
                        <em class="ti ti-plus text-2xl ml-auto" (click)="createNewJob($event)"
                            matTooltip="{{'text.new_job' | translate}}"
                            *ngIf="isJobAccessible && hasPermissionToNewJob"></em>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <jobs-list [options]="getJobListOptions()" (eventEmitter)="jobEventEmitHandler($event)"></jobs-list>
                <div class="h-80 flex flex-col items-center justify-center primary-font" *ngIf="jobsCount === 0">
                    <div class="flex flex-col items-center justify-center">
                        <img class="w-40 m-auto" src="assets/images/svgs/no_assets_found.svg"
                            alt="Add a job for this asset">
                        <h4 class="font-medium mt-4 text-secondary">
                            {{'assets.preview.panel.noJobs_found' | translate}}</h4>
                        <h4 class="font-medium mt-2 cursor-pointer underline text-primary"
                            *ngIf="isJobAccessible && hasPermissionToNewJob"
                            (click)="createNewJob($event)">
                            {{'create.new_job.text' | translate}}</h4>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion class="border-b" *ngFor="let key of object.keys(customFieldGroups)">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title class="text-secondary font-bold text-base primary-font">
                        {{customFieldGroups[key].isDefaultGroup ? ('text.other_details' |
                        translate) :
                        customFieldGroups[key].headerName}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="pt-4 px-10 primary-font">
                    <custom-fields [options]="getcustomFieldOptions(customFieldGroups[key].custom_fields)"></custom-fields>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>